<div mat-dialog-title>
  <p class="unit-title">{{data.i18n| translate: {unit: data.unit.name} }}</p>
  <button  mat-dialog-close>
    <i class="fa fa-times"></i>
  </button>
</div>

<mat-dialog-content>
  @for (tag of data.tags; track tag) {
    <p>{{tag.name}}</p>
  }
</mat-dialog-content>
